export default "__VITE_ASSET__DJG4$G5___"